import React from "react";
import { Link } from "react-router-dom";
import "./Service.css";

const services = [
  {
    icon: "home-outline",
    name: "Doctor Home Visit",
    desc: "Qualified doctors come to your home - no hospital queues or travel stress.",
    slug: "doctor-home-visit",
  },
  {
    icon: "business-outline",
    name: "Corporate Staff Medical Assessment",
    desc: "Comprehensive health checks for your workforce at your workplace.",
    slug: "corporate-health-assessment",
  },
  {
    icon: "woman-outline",
    name: "Antenatal & Maternal Care",
    desc: "Expert maternal health services from qualified midwives, at home.",
    slug: "antenatal-maternal-care",
  },
  {
    icon: "bed-outline",
    name: "Hospital at Home Care",
    desc: "Full hospital-level nursing and bedside medical care at home.",
    slug: "hospital-at-home",
  },
  {
    icon: "school-outline",
    name: "School Medical Examination",
    desc: "On-site health screenings and wellness checks for students.",
    slug: "school-medical-examination",
  },
  {
    icon: "refresh-circle-outline",
    name: "Chronic Disease Care",
    desc: "Ongoing management and monitoring for chronic health conditions.",
    slug: "chronic-disease-care",
  },
  {
    icon: "pulse-outline",
    name: "Remote Patient Monitoring",
    desc: "Tech-enabled monitoring so your recovery is tracked with precision.",
    slug: "remote-patient-monitoring",
  },
  {
    icon: "link-outline",
    name: "Referral & Tertiary Care",
    desc: "Seamless coordination with leading hospitals and specialists.",
    slug: "referral-tertiary",
  },
  {
    icon: "videocam-outline",
    name: "Telemedicine",
    desc: "Online doctor consultations - quality care from wherever you are.",
    slug: "telemedicine",
  },
];

export default function Services() {
  return (
    <section
      className="services-home-section"
      aria-labelledby="services-heading"
    >
      <div className="container">
        {/* Header */}
        <div className="services-header" data-aos="fade-up">
          <div className="section-label">
            <ion-icon name="medkit-outline"></ion-icon>
            What We Offer
          </div>
          <h2 id="services-heading">Yitalife Healthcare Services</h2>
          <p>
            Holistic, professional, equitable home-based and outdoor healthcare
            packages - designed for you, delivered to you.
          </p>
        </div>

        {/* Cards */}
        <div className="row">
          {services.map((svc, i) => (
            <div
              className="col-lg-4 col-md-6 col-sm-12"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 60}
            >
              <Link
                to={`/services/${svc.slug}`}
                className="service-card-link"
                aria-label={`Learn about ${svc.name}`}
              >
                <div className="service-card">
                  <div className="service-card-icon">
                    <ion-icon name={svc.icon}></ion-icon>
                  </div>
                  <h5>{svc.name}</h5>
                  <p>{svc.desc}</p>
                  <span className="service-card-more">
                    Learn more{" "}
                    <ion-icon name="arrow-forward-outline"></ion-icon>
                  </span>
                </div>
              </Link>
            </div>
          ))}
        </div>

        {/* View More */}
        <div className="services-view-more" data-aos="fade-left">
          <Link to="/Services">
            View All Services
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </Link>
        </div>
      </div>
    </section>
  );
}
